import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';

import * as _ from 'lodash';
import { Log } from "ng2-logger";
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
    selector: 'app-picklist',
    templateUrl: 'picklist.component.html',
    styleUrls: ['picklist.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: PicklistComponent,
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.Default
})
export class PicklistComponent implements OnInit, OnChanges, ControlValueAccessor {
    _logger = Log.create(PicklistComponent.name);

    @Output() selectionChange = new EventEmitter<any>();

    @Input() displayField = 'name';
    @Input() valueField = 'id';
    @Input() sourceHeader;
    @Input() targetHeader;
    @Input() infoLabel;
    @Input() sourceFilterPlaceholder = "Search";
    @Input() targetFilterPlaceholder = "Search";
    @Input() disabled = false;
    @Input() source = [];
    @Input() hasTooltip = false;
    @Input() responsive = true;
    @Input() dragDrop = true;
    @Input() target = [];
    @Input() formControl: UntypedFormControl;
    @Input() showValidations = false;
    @Input() icon = '';

    @Output() moveToSource = new EventEmitter<any>();
    @Output() moveToTarget = new EventEmitter<any>();

    private onChangeCallback: (_: any) => {};
    private onTouchedCallback: (_: any) => {};

    filteredSource = [];

    constructor() {
    }

    ngOnInit(): void {
        this.filterSourceByTarget();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['target'] || changes['source']) {
            this.filterSourceByTarget();
        }
    }

    onMoveToTarget() {
        this.moveToTarget.emit(this.target);
        this.propagateChanges(this.target);
    }

    onMoveToSource() {
        this.moveToSource.emit(this.source);
        this.propagateChanges(this.target);
    }

    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    writeValue(val: any): void {
        this.target = val;
    }

    private filterSourceByTarget() {
        this.filteredSource = _.differenceBy(this.source, this.target, 'id');
    }

    private propagateChanges(target) {
        if (this.onChangeCallback) {
            this.onChangeCallback(target);
        }
    }
}
